import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/referrals";
import { getReferralsListResponse, getReferralsRewardsResponse } from "./slice";
import { showSnackMsg } from "../../utils/Helpers";
import { setCanShowEmptyState, setSkeletonObject } from "../Loader/slice";

export function* getReferralsListSaga({ payload }) {
  try {
    yield put(getReferralsListResponse({}));
    yield put(setSkeletonObject({ field: "table", value: true }));
    const response = yield call(apis.getReferralsList, payload);
    const referralsList = response.data?.referrals;
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
      totalReferrals: +response.headers["total-count"],
      totalRegisteredInvitees:
        response.data?.["not_pending_registration_referrals"],
      totalPendingInvitees: response.data?.["pending_registration_referrals"],
    };
    yield put(getReferralsListResponse({ referralsList, meta }));
    yield put(setSkeletonObject({ field: "table", value: false }));
    if (referralsList.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getReferralsRewardsSaga({ payload }) {
  try {
    yield put(getReferralsRewardsResponse({}));
    yield put(setSkeletonObject({ field: "table", value: true }));
    const response = yield call(apis.getReferralsRewards, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
      totalEarnedRewards: response?.data?.["total_earned_referrals"],
      totalNumberRedeemedRewards: response?.data?.["total_redeemed_referrals"],
      totalAmountRedeemedRewards: response?.data?.["total_amount_redeemed"],
      totalExpiredRewards: response?.data?.["total_redemption_expired_rewards"],
    };
    const referralsRewards = response.data?.referral_stats;
    yield put(getReferralsRewardsResponse({ referralsRewards, meta }));
    yield put(setSkeletonObject({ field: "table", value: false }));
    if (referralsRewards.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export default function* ReferralsSagas() {
  yield takeEvery("referrals/getReferralsListRequest", getReferralsListSaga);
  yield takeEvery(
    "referrals/getReferralsRewardsRequest",
    getReferralsRewardsSaga
  );
}
